//import jQuery from 'jquery'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
//import CustomAnimation from '../animation/customAnimation';
import jQuery from "jquery";

//const customAnmation = new CustomAnimation();
let showNav = false;

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

class ResourcesDetail {
  init() {
    this.initPage();
    this.initAccordion();
    this.initParallax();
  }

  initPage = () => {

    $('.burger').on('click', function() {
      $(this).toggleClass('burger-close');
      if (showNav == false)
      {
        $('.resources_content_nav').addClass('show');
        showNav = true;
      }
      else {
        $('.resources_content_nav').removeClass('show');
        showNav = false;
      }
    });

    var searchParam = getUrlParameter('search');
    if(searchParam == "" || searchParam == false) {
      jQuery('.search_result').addClass('hide');
    }
    else  {
      jQuery('.search_result').removeClass('hide');
      $('html, body').scrollTop($("#business_boost").offset().top);
    }
  }

  initAccordion = () => {
    // Click-Handler für FAQ-Buttons
    jQuery('.button_faq').click(function(e){
      e.preventDefault();

      const $btn = jQuery(this);
      const $content = $btn.next('.faq_content');

      $content.slideToggle(300, () => {
        // Nach dem Umschalten Layout für ScrollTrigger aktualisieren
        ScrollTrigger.refresh();
      });

      // Toggle open-Klasse nur für das geklickte Element
      $btn.toggleClass('open');
    });

    // Alle FAQ-Accordion-Elemente beim Start aufklappen
    //jQuery('.button_faq').each(function() {
    //  jQuery(this).addClass('open');
    //  jQuery(this).next('.faq_content').show(); // Direkt anzeigen ohne Animation
    //});

    // Nur das erste FAQ-Element beim Start öffnen
    const $firstFaqButton = jQuery('.button_faq').first();
    $firstFaqButton.addClass('open');
    $firstFaqButton.next('.faq_content').show(); // Direkt anzeigen ohne Animation


    // Click-Handler für Question-Accordion-Buttons
    jQuery('.button_question').click(function(e){
      e.preventDefault();

      const $btn = jQuery(this);
      const $answer = $btn
        .closest('.basic_content_question')       // hoch zum Wrapper
        .next('.basic_content_answer');          // das nächste Antwort-Element

      $answer.slideToggle(300, () => {
        // Nach dem Umschalten Layout für ScrollTrigger aktualisieren
        ScrollTrigger.refresh();
      });

      // Toggle open-Klasse nur für das geklickte Element
      $btn.toggleClass('open');
    });


    // Alle Question-Accordion-Elemente beim Start aufklappen
    jQuery('.button_question').each(function() {

      if(jQuery(this).hasClass('open')) {
        jQuery(this).addClass('open');
        jQuery(this)
          .closest('.basic_content_question')
          .next('.basic_content_answer')
          .show(); // Direkt anzeigen ohne Animation
      }

    });
  }

  initAccordion_old = () => {
    // Click-Handler für Accordion-Buttons
    $('.button_faq').click(function(e){
      e.preventDefault();
      $(this).next(".faq_content").slideToggle();

      // Toggle open-Klasse nur für das geklickte Element
      $(this).toggleClass('open');
    });

    // Alle Accordion-Elemente beim Start aufklappen
    $('.button_faq').each(function() {
      $(this).addClass('open');
      $(this).next('.faq_content').show(); // Direkt anzeigen ohne Animation
    });


    // Click-Handler für Accordion-Buttons
    $('.button_question').click(function(e){
      e.preventDefault();

      $(this)
        .closest('.basic_content_question')       // hoch zum Wrapper
        .next('.basic_content_answer')            // das nächste Antwort-Element
        .slideToggle();

      // Toggle open-Klasse nur für das geklickte Element
      $(this).toggleClass('open');
    });

    // Alle Accordion-Elemente beim Start aufklappen
    $('.button_question').each(function() {
      $(this).addClass('open');
      $(this)
        .closest('.basic_content_question')
        .next('.basic_content_answer')
        .show(); // Direkt anzeigen ohne Animation
    });
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

  }
}

export default ResourcesDetail;
